<template>
  <div class="task-result-cards">
    <el-row :gutter="16">
      <!-- 固定卷/随机卷共有卡片 -->
      <el-col :span="4">
        <div class="metric-card">
          <div class="metric-title">参考人数</div>
          <div class="metric-value">{{ data.totalStudents || 0 }}</div>
          <div class="metric-sub">有效作答 {{ data.validStudents || 0 }}人</div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="metric-card">
          <div class="metric-title">平均分</div>
          <div class="metric-value">
            {{ data.avgScore || '—' }}<span v-if="data.fullScore" class="metric-unit"> / {{ data.fullScore }}</span>
          </div>
          <div class="metric-sub">中位数 {{ data.medianScore || '—' }}</div>
        </div>
      </el-col>

      <!-- 固定卷特有卡片 -->
      <template v-if="isFixed">
        <el-col :span="5">
          <div class="metric-card">
            <div class="metric-title">整卷区分度</div>
            <div class="metric-value">{{ data.discrimination || '—' }}</div>
            <div class="metric-sub">{{ discriminationText }}</div>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="metric-card card-warning">
            <div class="metric-title">异常题目数</div>
            <div class="metric-value">{{ data.abnormalCount || 0 }}</div>
            <div class="metric-sub">{{ correctRateRangeText }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="metric-card">
            <div class="metric-title">实测难度系数</div>
            <div class="metric-value">{{ data.difficultyCoeff || '—' }}
              <span style="font-size: 12px ; color:cadetblue ;" v-if="data.difficultyDiffPercent">{{ difficultyDiffText }} {{ absDifficultyDiffPercent }}</span>
            </div>
            <div class="metric-sub">{{ difficultyLevelText }}</div>
            
          </div>
        </el-col>
      </template>

      <!-- 随机卷特有卡片 -->
      <template v-else>
        <el-col :span="5">
          <div class="metric-card">
            <div class="metric-title">题库总题数</div>
            <div class="metric-value">{{ data.totalQuestionCount || 0 }}</div>
            <div class="metric-sub">本次考试涉及题数</div>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="metric-card" :class="getDifficultyClass(data.difficultyDiffLevel)">
            <div class="metric-title">不同试卷难度差异</div>
            <div class="metric-value">{{ data.difficultyStdDev }}</div>
            <div class="metric-sub">{{ data.difficultyDiffDesc || data.difficultyDiffLevel || '' }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="metric-card">
            <div class="metric-title">实际生成试卷份数</div>
            <div class="metric-value">{{ data.paperCount || 0 }}</div>
            <div class="metric-sub">每份{{ data.questionPerPaper || 0 }}题</div>
          </div>
        </el-col>
      </template>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'TaskResultCards',
  props: {
    data: { type: Object, default: () => ({}) }
  },
  computed: {
    isFixed() {
      return String(this.data.paperForm) === '1'
    },
    difficultyLevelText() {
      const map = { 1: '容易', 2: '中等偏易', 3: '中等', 4: '中等偏难', 5: '难' }
      return map[this.data.difficultyLevel] || this.data.difficultyLevel || ''
    },
    discriminationText() {
      /*
      区分度优秀（≥0.40），试卷能很好区分不同水平考生
      区分度良好（0.30~0.40），区分能力较强
      区分度一般（0.20~0.30），部分题目需检查
      区分度不足（≤0.20），试卷区分能力差
      */ 
      const diff = Number(this.data.discrimination)
      if (Number.isNaN(diff) || diff === 0) return ''
      if (diff >= 0.4) return '优秀，试卷能很好区分不同水平考生'
      if (diff >= 0.3) return '良好，区分能力较强'
      if (diff >= 0.2) return '一般，部分题目需检查'
      return '不足，试卷区分能力差'
    },
    correctRateRangeText() {
      if (!this.data.abnormalCorrectRateRange) return ''
      return this.data.abnormalCorrectRateRange.includes('~')
        ? `正确率 <${this.data.abnormalCorrectRateRange.replace('~', ' 或 >')}`
        : this.data.abnormalCorrectRateRange
    },
    difficultyDiffText() {
      const diff = Number(this.data.difficultyDiffPercent)
      if (Number.isNaN(diff) || diff === 0) return '与预估一致'
      return diff > 0 ? '比预估难' : '比预估易'
    },
    absDifficultyDiffPercent() {
      const diff = Number(this.data.difficultyDiffPercent)
      return Number.isNaN(diff) ? '' : Math.abs(diff)
    }
  },
  methods: {
    getDifficultyClass(level) {
      const map = { '优秀': 'card-success', '良好': 'card-info', '一般': 'card-warning', '差': 'card-danger' }
      return map[level] || ''
    }
  }
}
</script>

<style lang="less" scoped>
.metric-card {
  background: #f5f7fa;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  min-height: 90px;
  .metric-title { font-size: 13px; color: #909399; margin-bottom: 8px; }
  .metric-value { font-size: 24px; font-weight: bold; color: #303133; }
  .metric-unit { font-size: 14px; font-weight: 400; color: #909399; }
  .metric-sub { font-size: 12px; color: #909399; margin-top: 4px; }
}
.card-success { background: #f0f9eb; .metric-value { color: #67C23A; } }
.card-info { background: #f4f4f5; .metric-value { color: #909399; } }
.card-warning { background: #fdf6ec; .metric-value { color: #E6A23C; } }
.card-danger { background: #fef0f0; .metric-value { color: #F56C6C; } }
</style>
